import React from 'react';
import './styling/Profile.css'; 
import logo from './styling/images/profile/logo.jpg'
import img1 from './styling/images/profile/2.png'
import img2 from './styling/images/profile/3.jpeg'
import img3 from './styling/images/profile/4.png'

const Profile = () => {
  const openPdfInNewTab = () => {
    
    const pdfUrl = `/company_profile/profile.pdf`;
    
    window.open(pdfUrl, '_blank');
  };
  return <div className='profile'>
    <button className="download-btn" onClick={openPdfInNewTab} >Download Profile</button>
      <div className='main'>
      <img src={logo} className='logo' alt="UPS"/>
      <div className='heading'>AROSE POWER TECHNOLOGIES</div>
      <div className="row">
      <div className="text">
     Established in year 1990, Arose Power Technologies
            is a trusted name in the electrical power solutions domain in Karachi, Pakistan. 
            With over 30 years of existence and experience, we offer complete range of electrical power solution products, 
            including Voltage Stabilizers, Uninterruptible Power Supplies (UPS), Online UPS, Solar Inverters, Solar Panels, Transformers, 
            Line Conditioners, Batteries, Drives (VFD), and other related essential electrical, electronic, and industrial power products.
            </div>
      
      </div>
      
        <div className="row">
            <div className="text">
              Over the years, we have built a solid reputation for delivering reliable power solutions to a wide range of clients, including private companies, corporate sectors, government and semi-government departments, as well as domestic and commercial sectors. Our commitment to excellence, quality sales, and exceptional after-sales services has earned us the trust of our clients.
            </div>
          
          <img src={img1} className='image1' alt="UPS"/>
        </div>
      
      
        <div className="row">
          
          <img src={img2} className='image1' alt="UPS"/>
            <div className="text">
            What sets Arose Power Technologies apart is our unwavering dedication to customer satisfaction. Our clients choose us because of our competitive and reasonable market prices, timely and effective responses, and a highly skilled technical support. Our experienced staff ensures that our customer gets the highest standards of quality and reliability.
            </div>
          
        </div>
      
        <div className="row">
          
            <div className="text">
            In addition to our extensive product offerings, we provide repair services and yearly service contracts to ensure the longevity and efficiency of your power systems. We also offer both in-city and up-city service, making us the go-to choice for all your power needs.
            </div>
          
            <img src={img3} className='image1' alt="UPS"/>
        
        </div>
      
    </div>
  </div>;
};

export default Profile;
